import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import './Common.css';
import './ar.css';


const ArService = ()=>{
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return(
        <div id="ar-game" className="page-container pb-5">
            <div data-aos="zoom-in" className="col-12 fw-bolder fs-1 text-white text-center my-5"><span className="gradient-text">Augmented Reality Games</span></div>
            <div className="container">
                <div className="row justify-content-around" >
                    <div className="col-11 col-md-4 p-0 rounded-5 ar-video-container">
                        <video className="rounded-5 w-100 h-100 zindex-1" data-aos="zoom-in" autoPlay muted playsInline loop style={{objectFit:"cover"}}>
                            <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src="https://cdn.pixabay.com/video/2022/04/25/115035-703067756_large.mp4">
                            </source>
                        </video>
                        <div className="text-white ar-text-container fs-5 zindex-2">
                            <p data-aos="fade-right" className="p-3 lead fs-4 fw-bold">
                                We specialize in creating innovative AR (Augmented Reality) games 
                                that merge the physical and digital worlds. Our games offer immersive, 
                                interactive experiences that engage players in exciting virtual adventures
                                overlaid onto their real-world environments.
                            </p>
                        </div>
                        <div data-aos="zoom-in" className="bg-highlight">
                        </div>
                    </div>
                    <div className="col-11 col-md-4 p-0 rounded-5 ar-video-container">
                        <video className="rounded-5 w-100 h-100 zindex-1" data-aos="zoom-in" autoPlay muted playsInline loop style={{objectFit:"cover"}}>
                            <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src="https://cdn.pixabay.com/video/2022/04/25/115037-703067766_large.mp4">
                            </source>
                        </video>
                        <div className="text-white ar-text-container fs-5 zindex-2">
                            <p data-aos="fade-right" className="p-3 lead fs-4 fw-bold">
                                By using cutting-edge AR technology, we bring unique, fun-filled experiences to life, 
                                perfect for entertainment, education, and brand engagement. 
                                Let’s bring your ideas to life with our creative and dynamic AR games!
                            </p>
                        </div>
                        <div data-aos="zoom-in" className="bg-highlight">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ArService;